'use strict';

function initScrollShrink(masthead) {
    // Two thresholds to prevent feedback-loop jitter:
    // The sticky header occupies flow space, so shrinking it drops scrollY by ~20px.
    // A single threshold would cause the class to toggle on/off repeatedly near that point.
    const SHRINK_AT   = 80;  // scroll past full header height → shrink
    const RESTORE_AT  = 20;  // clearly back near the top → restore

    const update = () => {
        if (masthead.classList.contains('is-scrolled')) {
            if (window.scrollY < RESTORE_AT) masthead.classList.remove('is-scrolled');
        } else {
            if (window.scrollY > SHRINK_AT)  masthead.classList.add('is-scrolled');
        }
    };

    window.addEventListener('scroll', update, { passive: true });
    update(); // correct state on load (e.g. browser scroll-position restore)
}

export function init() {
    const btn = document.querySelector('.masthead__hamburger');
    const nav = document.getElementById('navMain');
    const masthead = document.querySelector('.masthead');

    if (masthead) initScrollShrink(masthead);

    if (!btn || !nav) return;

    btn.addEventListener('click', (e) => {
        e.preventDefault();
        const isOpen = nav.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(isOpen));
    });

    // Close when clicking outside
    document.addEventListener('click', (e) => {
        if (!nav.classList.contains('is-open')) return;
        if (!nav.contains(e.target) && !btn.contains(e.target)) {
            nav.classList.remove('is-open');
            btn.setAttribute('aria-expanded', 'false');
        }
    });

    // Close on Escape
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && nav.classList.contains('is-open')) {
            nav.classList.remove('is-open');
            btn.setAttribute('aria-expanded', 'false');
            btn.focus();
        }
    });
}
